// import './modules/modernizr-custom';
import Accordions from './modules/accordion';
import Modals from './modules/modal';
// import Tabs from './modules/tabs';
// import Includes from './modules/include';
// import AnchorLink from './modules/anchorlink';
import HashUrl from './modules/hash_url';
import AgreeCheck from './modules/check';
// import './modules/carousel';
import Zaiko from './modules/zaiko';
// import ColorCart from './modules/colorcart';
// import Review from './modules/review';
// import './modules/timer';
import '../scss/index.scss';

// // YouCamメイクシミュレーター
// import YouCam from './modules/youcam';
// // API読み込み
// (function (d,k) {
//   var s = d.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = 'https://plugins-media.makeupar.com/c317/sdk.js?apiKey=' + k;
//   var x = d.getElementsByTagName('script')[0];
//   x.parentNode.insertBefore(s, x);
// })(document, 'y6xyy2zXnvV8pqT4m49JQ==')

// // ツール初期化
// window.ymkAsyncInit = function() {
//   YMK.init({'autoOpen': true,'language': 'jpn'});
//   window.YMK.addEventListener('loaded', function() {
//     // console.log('loaded!')
//     const vmModal = document.getElementById('modal-vm');
//     if(vmModal){
//       const envBox = vmModal.querySelector('.mod-vmmodal--vmcont_env');
//       const vmBtnBox = vmModal.querySelector('.mod-vmmodal--vmcont_function');
//       envBox.style.display = 'none';
//       vmBtnBox.style.display = 'block';
//     }
//   });
// }

document.addEventListener('DOMContentLoaded', function () {

  // //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!entry.target.classList.contains(zaikoFlag)) {
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
    root: null,
    rootMargin: "100px",
    threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if (carts) {
    carts.forEach(cart => zaikoio.observe(cart));
  }

  // // レビューAPI
  // const reviewCont = Array.from(document.querySelectorAll('.js-review'));
  // reviewCont.forEach((cont) => {
  //   new Review(cont);
  // });

  // //Accordion
  const accBtns = Array.from(document.querySelectorAll('.js-acc-btn2'));
  accBtns.forEach((accordionBtn) => {
    new Accordions(accordionBtn);
  });

  //Modal window
  const modalBtns = Array.from(document.querySelectorAll('.js-modal-open'));
  modalBtns.forEach((modalBtn) => {
    new Modals(modalBtn);
  });

  //YouCamメイクシミュレーター
  const vmModalBtns = Array.from(document.querySelectorAll('.js-vmmodal-open'));
  vmModalBtns.forEach((modalBtn) => {
    new YouCam(modalBtn);
  });

  // //タブ切り替え
  // const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
  // tabsBtn.forEach((tabBtn) => {
  //   new Tabs(tabBtn);
  // });

  // // 同意チェック
  const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  checkboxs.forEach((check) => {
    new AgreeCheck(check);
  });

  window.addEventListener('load', function () {

    // // 色玉在庫制御
    // const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
    // colorCarts.forEach((irodamabtn) => {
    //   new ColorCart(irodamabtn);
    // });

    //smooth anchor
    // 上部固定要素があれば指定する
    // const fixedContent = document.querySelector('.mod-fixednav.m-upper');
    //ページ内リンク
    let anchorLinks = Array.from(document.querySelectorAll('a'));
    anchorLinks.forEach((link) => {
      // new AnchorLink(link,fixedContent);
      // fixedContentなしVersion
      new AnchorLink(link);
    });
    //ハッシュ付きURLでアクセス
    // new HashUrl(fixedContent);
    // fixedContentなしVersion
    new HashUrl();

    
    function onClick(){
      var clickObj = $(".scClick3");
      clickObj.each (function(){
        var clickID = $(this).attr("data-clickID");
        var clickLink = $(this).attr("href");
        $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
      })
    }
    onClick();

  });

});

// セット品在庫判定
var setCart = $('.setZaiko');

$.each(setCart, function () {
  var thisSetCart = $(this);
  var jancode = thisSetCart.attr('data-shohincd');
  jancode = jancode.split(',');
  jancode = '&shohin_cd=' + jancode.join('&shohin_cd=');
  var shohinKbn = thisSetCart.attr('data-shohinkbn');
  var domain = document.domain;
  var apiUrl = "//www.shiseido.co.jp/sw/products/SWFG070740.seam";
  if (domain == "www.shiseido.co.jp" || domain == "test.www.shiseido.co.jp" || domain == "test4.www.shiseido.co.jp") {
    apiUrl = "/sw/products/SWFG070740.seam";
  }

  $.ajax({
    async: false,
    url: apiUrl,
    // url: "https://www.shiseido.co.jp/sw/products/SWFG070740.seam",
    data: "border=10&shohin_kbn=" + shohinKbn + jancode,
    dataType: "jsonp",
    success: function (data) {
      if (!data) {
        return;
      }
      var i = 0,
        max;
      var zaikoJudge = '';
      var i = 0,
        max;
      for (i = 0, max = data.length; i < max; i = i + 1) {
        zaikoJudge += data[i].zaiko_kbn;
      }
      if (zaikoJudge.indexOf('1') != -1) {
        thisSetCart.find('.zaikokbn1').show();

      } else if (zaikoJudge.indexOf('2') != -1) {
        thisSetCart.find('.zaikokbn2').show();
      } else if (zaikoJudge.indexOf('0') != -1) {
        thisSetCart.find('.zaikokbn0').show();
      } else if (zaikoJudge.indexOf('9') != -1) {
        thisSetCart.find('.zaikokbn9').show();
      }
    },
    error: function () {}
  })
});

$('#js-carousel2').slick({
  centerMode: true,
  centerPadding: '12%',
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  infinite: true
});


// アコーディオン
$('.js-acc-btn').on('click', function (evt) {
  evt.preventDefault();
  var thisUnit = $(this).parents('.js-acc');
  var thisCont = thisUnit.find('.js-acc-cont');
  var thisBtnTxt = thisUnit.find('.js-acc-btn span');
  var flagClass = 'm-opened';
  var slideTime = 300;
  if (thisUnit.hasClass(flagClass)) {
    //閉じる
    thisCont.slideUp(slideTime);
    thisUnit.removeClass(flagClass);
  } else {
    //開く
    thisCont.slideDown(slideTime);
    thisUnit.addClass(flagClass);
  }
});



var myPrice = 0;
var priceTaxin = '';

var janParameter = '';
var price = 0;
var cartUrl = '';
var janClick = '';

var fdcolorName = '';
var count = 0;

$('.js-prod_select').on('click', function (evt) {
  evt.preventDefault();
  var unit;
  var thisJan = '';
  var thisPrice = '';
  var thisZaiko = '';
  var thistype = '';
  var thisClick = '';

  unit = $(this).parent('.zaiko');
  thisJan = '&sweb_shohin_cd=' + unit.attr('data-shohincd');
  thisPrice = unit.attr('data-price');
  thisZaiko = unit.attr('data-zaiko');
  thistype = unit.attr('data-type');
  thisClick = '_' + unit.attr('data-shohincd');

  // console.log("thistype:",$('.item_display').find(thistype).length);

  if ($(this).hasClass('on')) { // すでにチェックが付いていたら削除
    $(this).removeClass('on');
    price = parseInt(price) - parseInt(thisPrice);
    janParameter = String(janParameter.replace(thisJan, ''));
    janClick = String(janClick.replace(thisClick, ''));
    $('.item_display').find('.' + thistype + '').html(' ');
    $('.item_display').find('.' + thistype + '').siblings().css('display', 'block');
    $('.item_display').find('.' + thistype + '').removeClass(thistype);
    $(this).parents('.product_cv_prod').find('a:not(.on)').parents('li').removeClass('prod_unselect');
    count--;
  } else { //　チェックが付いていなかったら追加
    $(this).addClass('on');
    fdcolorName = '<div class="item_detail"><p class="item_detail_img">' + $(this).find('.item_detail_img').html() + '</p><div class="item_detail_info"><p class="item_detail_name">' + $(this).find('.item_detail_name').html() + '</p><p class="item_detail_dtl">' + $(this).find('.item_detail_dtl').html() + '</p><p class="item_detail_price">' + $(this).find('.item_detail_price').html() + '</p></div></div>';

    if ($('.step_selected2').has("div").length) {
      $('.step_selected3').siblings().css('display', 'none');
      $('.step_selected3').addClass(thistype);
      $('.step_selected3').html(fdcolorName);
    } else {
      $('.step_selected2').siblings().css('display', 'none');
      $('.step_selected2').addClass(thistype);
      $('.step_selected2').html(fdcolorName);
    }

    price = parseInt(price) + parseInt(thisPrice);
    janParameter += String(thisJan);
    janClick += String(thisClick);
    count++;

    if (count == 2) {
      $(this).parents('.product_cv_prod').find('a:not(.on)').parents('li').addClass('prod_unselect');
    }
  }
  //console.log("count:",count);

  myPrice = 0;
  var checkList = $(".on").parents('li');
  for (var i = 0; i < checkList.length; i++) {
    var checkModel = checkList.eq(i).attr("data-price");
    myPrice = myPrice + parseInt(checkModel)
  }

  priceTaxin = parseInt(myPrice);
  priceTaxin = String(Math.round(priceTaxin)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  $('.total_money').text(priceTaxin);

  if (count < 2) {
    $('.cont').children('.item_display').find('.add_btn').removeClass('on');
    $('.cont').children('.item_display').find('.add_btn a').attr('href', '#');
  } else {
    var cartUrl = '/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin' + janParameter + '&online_shohin_ctlg_kbn=1&keyword_flg=1'
    $('.cont').children('.item_display').find('.add_btn').addClass('on');
    $('.cont').children('.item_display').find('.add_btn a').attr('href', cartUrl);
    var clickID = "cartbtn" + janClick;
    $('.cont').children('.item_display').find('.add_btn a').attr("onclick", "_sc.gene_click('" + clickID + "','" + cartUrl + "');");
  }
});


//
// ---------- アクション ---------- //
//

var _$window = $(window);
var _$body = $("body");
var _$contents = $(".lp_contents");

// アンカーリンク
var _anchorLink = AnchorLink({
  $targetArr: _$contents.find(".anchorLink")
});
_anchorLink.init();

// 在庫チェック
var _zaikoCheck = ZaikoCheck({
  $targetArr: _$contents.find(".zaiko")
});
_zaikoCheck.init();
_zaikoCheck.connect();


//
// ---------- モジュール ---------- //
//

function AnchorLink(params) {

  var _$targetArr = params["$targetArr"];

  return {
    init: init
  };

  // ---------- パブリックメソッド ---------- //

  function init() {
    if (!_$targetArr) return;
    _$targetArr.each(function () {
      $(this).click(function (evt) {
        evt.preventDefault();
        //
        var targetId = $(this).attr("href");
        if (targetId) {
          try {
            $("html, body").stop().animate({
              scrollTop: $(targetId).offset().top
            }, {
              duration: 1000,
              easing: "swing"
            })
          } catch (e) {
            return false;
          }
        }
      });
    });
  }

  // ---------- プライベートメソッド ---------- //

}

/**
 * 在庫チェック
 * @param params
 * @returns {{init: Function, connect: Function}}
 * @constructor
 */
function ZaikoCheck(params) {

  var _$targetArr = params["$targetArr"];
  var _collection = [];
  var _params = "";

  return {
    init: init,
    connect: connect
  };

  // ---------- パブリックメソッド ---------- //

  function init() {
    if (!_$targetArr) return;
    // 送信用パラメータと対象オブジェクトの取得
    _collection = [];
    _$targetArr.each(function () {
      var $this = $(this);
      var shohin_kbn = $this.attr("data-shohinkbn");
      var shohin_cd = $this.attr("data-shohincd");
      if (shohin_kbn && shohin_kbn != "") {
        var hasThis = false;
        var x, sum;
        for (x = 0, sum = _collection.length; x < sum; x++) {
          if (_collection[x].shohin_kbn == shohin_kbn) {
            //すでにある区分に追加
            (function ($this) {
              var flg = false;
              var i = 0,
                max;
              var targetIndex = x;
              var targetCollect = _collection[targetIndex].collect;
              var targetParams = _collection[targetIndex].params;
              if (shohin_cd && shohin_cd != "") {
                for (i = 0, max = targetCollect.length; i < max; i = i + 1) {
                  if (targetCollect[i].shohin_cd == shohin_cd) {
                    targetCollect[i].$targetArr.push($this);
                    flg = true;
                    break;
                  }
                }
              }
              if (!flg) {
                targetCollect.push({
                  shohin_cd: shohin_cd,
                  $targetArr: [$this]
                });
                targetParams += "&shohin_cd=" + shohin_cd;
                _collection[targetIndex].params = targetParams;
              }

            }($this));

            hasThis = true;
            break;
          }
        };
        if (!hasThis) {
          //区分を新規
          _collection.push({
            shohin_kbn: shohin_kbn,
            collect: [],
            params: ''
          });
          if (shohin_cd && shohin_cd != "") {
            (function ($this) {
              var targetIndex = _collection.length - 1;
              var targetCollect = _collection[targetIndex].collect;
              var targetParams = _collection[targetIndex].params;

              targetCollect.push({
                shohin_cd: shohin_cd,
                $targetArr: [$this]
              });
              targetParams += "&shohin_cd=" + shohin_cd;
              _collection[targetIndex].params = targetParams;

            }($this));
          }
        }
      }


    });
    console.log(_collection)
  }

  function connect() {
    if (!_$targetArr) return;
    $.each(_collection, function (index, val) {
      var shohin_kbn = val.shohin_kbn;
      var params = val.params;
      var collect = val.collect;
      var domain = document.domain;
      var apiUrl = "//www.shiseido.co.jp/sw/products/SWFG070740.seam";
      if (domain == "www.shiseido.co.jp" || domain == "test.www.shiseido.co.jp" || domain == "test4.www.shiseido.co.jp") {
        apiUrl = "/sw/products/SWFG070740.seam";
      }

      $.ajax({
        async: false,
        url: apiUrl,
        data: "border=20&shohin_kbn=" + shohin_kbn + params,
        dataType: "jsonp",
        success: function (data) {
          if (!data) {
            return;
          }
          //console.log(data)
          var i = 0,
            max;
          for (i = 0, max = data.length; i < max; i = i + 1) {
            var j = 0,
              max2;
            for (j = 0, max2 = collect.length; j < max2; j = j + 1) {
              if (collect[j].shohin_cd == data[i].shohin_cd) {
                var k = 0,
                  max3;
                for (k = 0, max3 = collect[j].$targetArr.length; k < max3; k = k + 1) {
                  //data[i].zaiko_kbn = null;
                  //data[i].zaiko_kbn = 0;
                  //data[i].zaiko_kbn = 1;
                  //data[i].zaiko_kbn = 2;
                  //data[i].zaiko_kbn = 9;

                  if (data[i].zaiko_kbn == 0) {
                    collect[j].$targetArr[k].find(".zaikokbn0").each(function () {
                      $(this).css({
                        display: "block"
                      })
                    })
                  } else if (data[i].zaiko_kbn == 1) {
                    collect[j].$targetArr[k].find(".zaikokbn1").each(function () {
                      $(this).css({
                        display: "block"
                      })
                    })
                  } else if (data[i].zaiko_kbn == 2) {
                    collect[j].$targetArr[k].find(".zaikokbn2").each(function () {
                      $(this).css({
                        display: "block"
                      })
                    });
                  } else if (data[i].zaiko_kbn == 9) {
                    collect[j].$targetArr[k].find(".zaikokbn9").each(function () {
                      $(this).css({
                        display: "block"
                      })
                    });
                  }
                }
              }
            }
          }
        },
        error: function () {}
      })
    });

  }
  // ---------- プライベートメソッド ---------- //

}

function onClick() {
  var clickObj = $(".scClick");
  clickObj.each(function () {
    var clickID = "cartbtn_" + $(this).parent(".zaiko").attr("data-shohincd");
    console.log(clickID);
    var clickLink = $(this).attr("href");
    $(this).attr("onclick", "_sc.gene_click('" + clickID + "','" + clickLink + "');");
  })
}
onClick();

function onClick2(){
  var clickObj = $(".scClick2");
  clickObj.each (function(){
    var clickID = $(this).attr("data-clickID");
    var clickLink = $(this).attr("href");
    $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
  })
}
onClick2();